<template>
    <div>
        <div v-if="loading">
            <v-sheet class="rounded">
                <v-skeleton-loader
                    class="hidden-sm-and-down"
                    dark
                    dense
                    type="list-item-avatar,list-item-avatar,list-item-avatar,list-item-avatar,list-item-avatar,list-item-avatar"
                ></v-skeleton-loader>
            </v-sheet>
        </div>
        <div
            v-else
            :class="{
                'pa-0 mobileTabs mb-2': $breakpoint.mdAndUp,
                'pa-0': $breakpoint.smAndDown
            }"
        >
            <v-list-item
                v-if="$auth.loggedIn && $breakpoint.mdAndUp"
                class="d-none"
                :color="$vuetify.theme.dark ? 'white' : 'black'"
            >
                <v-list-item-content>
                    <v-list-item-title
                        class="uname d-flex align-items-center justify-content-start white--text text-capitalize"
                    >
                        <span
                            ><img
                                width="40"
                                height="40"
                                class="mr-4 rounded-circle w-15 d-inline-block"
                                src="@/assets/images/profile_g.webp"
                        /></span>
                        <span> {{ $auth.user.username }}</span>
                    </v-list-item-title>
                </v-list-item-content>
                <v-btn
                    outlined
                    border-none
                    style="border: none; color: white"
                    :class="{
                        'd-none': $breakpoint.mdAndUp
                    }"
                    @click="mobileDrawer = !mobileDrawer"
                >
                    <v-icon size="18">mdi-close </v-icon>
                </v-btn>
            </v-list-item>
            <div
                v-if="$auth.loggedIn && $breakpoint.mdAndUp"
                class="d-none px-4 py-0"
            >
                <hr
                    class="v-divider primary"
                    :class="
                        $vuetify.theme.dark ? 'theme--dark' : 'theme--light'
                    "
                />
            </div>
            <div v-if="orientation === 'horizontal'">
                <v-tabs
                    v-model="model"
                    height="90"
                    icons-and-text
                    center-active
                    hide-slider
                    grow
                    class="sportsbook-category-tabs--mobile"
                >
                    <!-- <v-tab to="/" class="mobile-menu-blocks">
                <v-icon icon color="yellow" size="20">mdi-play-circle</v-icon>
                <v-icon class="green--text" size="20"> mdi-play-circle </v-icon>
                <img
                  src="@/assets/images/menu/Inplay.webp"
                  width="20"
                  class="rounded-t-lg justify-content-center"
                  aspect-ratio="1"
                />
                Inplay
              </v-tab> -->
                    <v-tab
                        v-for="game in filterOut"
                        :id="game.name"
                        :key="game._id"
                        :to="`/sportsbook/${
                            [
                                'horse racing',
                                'horse-racing',
                                'greyhound racing',
                                'greyhound-racing'
                            ].includes(game.name.toLowerCase())
                                ? kebabCase(game.name)
                                : game.name
                        }`"
                    >
                        <div class="tab-round-icon-container">
                            <v-badge
                                color="primary"
                                :content="game.allMarketCount"
                                :value="game.allMarketCount"
                                class="d-flex align-items-center"
                            >
                                <v-img
                                    width="23"
                                    max-height="23"
                                    contain
                                    rounded
                                    :src="getGameSrc(game.name)"
                                ></v-img>
                            </v-badge>
                        </div>
                        <div class="tab-label">
                            {{ game.name?.replace("Racing", "") }}
                        </div>
                    </v-tab>
                    <v-tab v-if="$auth.user" to="/favorites">
                        <div class="tab-round-icon-container">
                            <v-icon icon color="yellow" size="20"
                                >mdi mdi-star
                            </v-icon>
                        </div>
                        <div class="tab-label">Favorites</div>
                    </v-tab>
                    <!-- <v-tab
                class="
                  text-center
                  d-flex
                  flex-column
                  text-decoration-none text-white
                  mobile-menu-blocks
                  v-tab
                "
                @click="megaMenuDrawer = !megaMenuDrawer"
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/814/814159.png"
                  alt=""
                  class="more"
                /><span color="primary" style="font-size: 0.7rem">More</span>
              </v-tab> -->
                </v-tabs>
            </div>
            <v-list
                v-else
                class="left-panel pa-0 rounded d-flex vertical-list"
                :class="
                    (scrollClass,
                    {
                        'pa-0': $breakpoint.mdAndUp,
                        'pa-2': $breakpoint.smAndDown
                    })
                "
            >
                <!-- menu for games -->
                <div
                    v-if="!$route.params.category && !$route.params.subCategory"
                    class="col-12 px-0 games game-left one py-0 py-8 py-md-4"
                >
                    <template v-for="game in games">
                        <v-list-item
                            :id="game.name"
                            :key="game._id"
                            :disabled="game.allMarketCount == 0"
                            :to="
                                [
                                    'horse racing',
                                    'horse-racing',
                                    'greyhound racing',
                                    'greyhound-racing'
                                ].includes(game.name.toLowerCase())
                                    ? `/sportsbook/${game.name
                                          .replace(' ', '-')
                                          .toLowerCase()}`
                                    : `/sportsbook/${game.name}`
                            "
                            dense
                        >
                            <v-list-item-avatar tile size="22">
                                <v-img :src="getGameSrc(game.name)"></v-img>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title style="text-align: start">
                                    {{ game.name }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action v-if="game.allMarketCount > 0">
                                <v-badge
                                    class="ma-0"
                                    :color="domainUrl ? 'primary' : 'superBlue'"
                                    :content="game.allMarketCount"
                                    :value="game.allMarketCount"
                                    inline
                                >
                                </v-badge>
                            </v-list-item-action>
                        </v-list-item>
                        <!-- <v-divider :key="'divider' + game.name"></v-divider> -->
                    </template>
                    <!-- Static menu for Casino and Cardgames -->
                    <div class="">
                        <!-- <v-list-item
            v-if="!$auth.user || $auth.user.casino"
            id="casino"
            to="/casino"
          >
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="casino"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Live Casino</div>
              </div>
            </div>
          </v-list-item>
          <hr
            v-if="!$auth.user || $auth.user.cardgame"
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          /> -->
                        <!-- <v-list-item
            v-if="
              (!$auth.user || $auth.user.cardgame) &&
              domain !== 'matrixexch9.club'
            "
            to="/live-cards"
          > -->
                        <v-list-item
                            v-if="
                                fantasyOnOff && version.projectCode != 'bd-new'
                            "
                            to="/fantasybook"
                        >
                            <div
                                class="v-list-item--dense v-list-item--link d-flex"
                            >
                                <div class="v-avatar rounded-0 v-avatar--tile">
                                    <div
                                        class="v-image v-responsive theme--dark"
                                    >
                                        <div class="v-responsive"></div>
                                        <v-img
                                            max-height="25"
                                            max-width="25"
                                            class="v-image__image v-image__image--cover rounded"
                                            :lazy-src="`${CDN_IMG_URL}/fantasybookicon.webp`"
                                            :src="`${CDN_IMG_URL}/fantasybookicon.webp`"
                                        ></v-img>
                                        <div class="v-responsive"></div>
                                    </div>
                                </div>
                                <div class="v-list-item__content pl-4">
                                    <div class="v-list-item__title">
                                        Fantasy Pro
                                    </div>
                                </div>
                            </div>
                        </v-list-item>

                        <v-list-item
                            v-if="!$auth.user || $auth.user.cardgame"
                            to="/live-cards"
                        >
                            <div
                                class="v-list-item--dense v-list-item--link d-flex"
                            >
                                <div class="v-avatar rounded-0 v-avatar--tile">
                                    <div
                                        class="v-image v-responsive theme--dark"
                                    >
                                        <div class="v-responsive"></div>
                                        <v-img
                                            max-height="25"
                                            max-width="25"
                                            class="v-image__image v-image__image--cover rounded"
                                            :src="cardicon"
                                        ></v-img>
                                        <div class="v-responsive"></div>
                                    </div>
                                </div>
                                <div class="v-list-item__content pl-4">
                                    <div class="v-list-item__title">
                                        Live Card
                                    </div>
                                </div>
                            </div>
                        </v-list-item>
                        <!-- <hr
              v-if="!$auth.user || $auth.user.cardgame"
              class="v-divider"
              :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
            /> -->
                        <!-- <v-list-item
            v-if="!$auth.user || $auth.user.casino"
            id="casino"
            to="/casino"
          >
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="casino"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Casino</div>
              </div>
            </div>
          </v-list-item>
          <hr
            v-if="!$auth.user || $auth.user.cardgame"
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          /> -->
                        <!-- <v-list-item
            v-if="
              (domain === 'zodexchange.com' || domain === 'matrixexch9.club') &&
              (!$auth.user || $auth.user.liveGame)
            "
            id="cardgames"
            to="/live-games"
          >
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="cardicon"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Live Games</div>
              </div>
            </div>
          </v-list-item> -->
                        <!-- <hr
            v-if="
              (domain === 'zodexchange.com' || domain === 'matrixexch9.club') &&
              (!$auth.user || $auth.user.liveGame)
            "
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          /> -->
                        <v-list-item
                            v-if="!$auth.user || $auth.user.casino"
                            to="/casino-slots"
                        >
                            <div
                                class="v-list-item--dense v-list-item--link d-flex"
                            >
                                <div
                                    class="v-avatar rounded-0 v-avatar--tile pr-4"
                                >
                                    <div
                                        class="v-image v-responsive theme--dark"
                                    >
                                        <div class="v-responsive"></div>
                                        <v-img
                                            max-height="25"
                                            max-width="25"
                                            class="v-image__image v-image__image--cover rounded"
                                            :src="sloticon"
                                        ></v-img>
                                        <div class="v-responsive"></div>
                                    </div>
                                </div>
                                <div class="v-list-item__content">
                                    <div class="v-list-item__title">
                                        Slot Games
                                    </div>
                                </div>
                            </div>
                        </v-list-item>
                        <!-- <hr
              v-if="!$auth.user || $auth.user.casino"
              class="v-divider"
              :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
            /> -->
                        <v-list-item
                            v-if="
                                (!$auth.user || $auth.user.horseRacing) &&
                                domain === 'playtowin.club'
                            "
                            to="/racing"
                            class="d-none"
                        >
                            <div
                                class="v-list-item--dense v-list-item--link d-flex"
                            >
                                <div
                                    class="v-avatar rounded v-avatar--tile pr-4"
                                >
                                    <div
                                        class="v-image v-responsive theme--dark"
                                    >
                                        <div class="v-responsive"></div>
                                        <v-img
                                            max-height="25"
                                            max-width="25"
                                            class="v-image__image v-image__image--cover rounded"
                                            :src="
                                                require('@/assets/images/menu/Horse-Racing.webp')
                                            "
                                        ></v-img>
                                        <div class="v-responsive"></div>
                                    </div>
                                </div>
                                <div class="v-list-item__content">
                                    <div class="v-list-item__title">
                                        Horse Racing
                                    </div>
                                </div>
                            </div>
                        </v-list-item>
                        <!-- <hr
              v-if="
                (!$auth.user || $auth.user.horseRacing) &&
                domain === 'playtowin.club'
              "
              class="v-divider"
              :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
            /> -->
                        <!-- <v-list-item v-if="domain === 'playtowin.club'" to="/wac">
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="greyhound"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Wac</div>
              </div>
            </div></v-list-item
          >
          <hr
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          /> -->
                        <v-list-item
                            v-if="domain === 'playtowin.club'"
                            to="/finsa"
                            class="d-none"
                        >
                            <div
                                class="v-list-item--dense v-list-item--link d-flex"
                            >
                                <div
                                    class="v-avatar rounded-0 v-avatar--tile pr-4"
                                >
                                    <div
                                        class="v-image v-responsive theme--dark"
                                    >
                                        <div class="v-responsive"></div>
                                        <v-img
                                            max-height="25"
                                            max-width="25"
                                            class="v-image__image v-image__image--cover rounded"
                                            :src="
                                                require('@/assets/images/menu/Finance-Trading.webp')
                                            "
                                        ></v-img>
                                        <div class="v-responsive"></div>
                                    </div>
                                </div>
                                <div class="v-list-item__content">
                                    <div class="v-list-item__title">Finsa</div>
                                </div>
                            </div>
                        </v-list-item>
                        <!-- <hr
            v-if="!$auth.user || $auth.user.horseRacing"
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          />
          <v-list-item v-if="domain == 'playtowin.club'" to="/racing">
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="greyhound"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Greyhound</div>
              </div>
            </div>
          </v-list-item> -->
                        <!-- <hr
              v-if="domain == 'playtowin.club'"
              class="v-divider"
              :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
            /> -->
                        <template
                            v-for="premiumSportsbook in premiumSportsbookData"
                        >
                            <v-list-item
                                v-if="
                                    !$auth.user ||
                                    !$auth.user.loggedIn ||
                                    $auth.user.premiumsportsbook
                                "
                                :id="premiumSportsbook.name"
                                :key="premiumSportsbook._id"
                                :to="`/premium-sportsbook?bt-path=${premiumSportsbook.path}`"
                                dense
                            >
                                <v-list-item-avatar tile size="22">
                                    <v-img
                                        :src="
                                            premiumSportsbook.logo
                                                | newOptimizedImage(
                                                    100,
                                                    premiumSportsbook.logo
                                                )
                                        "
                                    ></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title
                                        style="text-align: start"
                                    >
                                        {{ premiumSportsbook.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <!-- <v-divider
                v-if="index < limitBy"
                :key="'divider' + premiumSportsbook.name"
                class="v-divider"
                :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
              ></v-divider> -->
                        </template>
                        <template>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-avatar></v-list-item-avatar>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-avatar></v-list-item-avatar>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <!-- <template
              v-if="
                (!$auth.user || $auth.user.premiumsportsbook) &&
                premiumSportsbookData &&
                premiumSportsbookData.length > 3 &&
                $breakpoint.mdAndUp
              "
            >
              <v-list-item
                @click="viewMore(defaultLimit, premiumSportsbookData.length)"
              >
                <v-list-item-avatar tile size="22">
                  <v-icon medium color="white"> {{ iconText }}</v-icon>
                </v-list-item-avatar>
                {{ limitBy === 0 ? 'View more' : 'View Less' }}
              </v-list-item>
            </template> -->
                        <!-- <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites> -->
                    </div>
                    <!-- Static menu for Casino and Cardgames -->
                </div>
                <!-- menu for compition -->
                <div
                    v-if="$route.params.category && !$route.params.subCategory"
                    class="col-12 pa-0 games game-left two py-4"
                >
                    <v-list-item :to="`/sportsbook`">
                        <v-list-item-avatar tile size="22">
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title> Sports </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        id="game"
                        :to="`/sportsbook/${gameName}`"
                        dense
                        class="primary"
                    >
                        <v-list-item-avatar
                            tile
                            size="22"
                            :class="{
                                'horse-racing-title': gameName == 'horse-racing'
                            }"
                        >
                            <v-img :src="getGameSrc(gameName)"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ startCase(gameName) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        id="previous"
                        dense
                        class="primary-lighten"
                        @click="goBack()"
                    >
                        <v-list-item-avatar tile size="22">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title> Previous </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- <v-divider></v-divider> -->
                    <competitions
                        v-if="!isEmpty"
                        :compitions="compitions"
                    ></competitions>
                    <!-- <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites> -->
                </div>
                <!-- menu for EventCompetition -->
                <div
                    v-if="$route.params.category && $route.params.subCategory"
                    class="col-12 pa-0 games game-left three py-4"
                >
                    <v-list-item id="game" :to="`/sportsbook`">
                        <v-list-item-avatar tile size="22">
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title> Sports </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        id="game"
                        :to="`/sportsbook/${gameName}`"
                        dense
                        class="primary"
                    >
                        <v-list-item-avatar
                            tile
                            size="22"
                            :class="{
                                'horse-racing-title': gameName == 'horse-racing'
                            }"
                        >
                            <v-img :src="getGameSrc(gameName)"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ startCase(gameName) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        id="previous"
                        class="primary-lighten"
                        dense
                        @click="goBack()"
                    >
                        <v-list-item-avatar tile size="22">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title> Previous </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- <v-divider></v-divider> -->
                    <event-competitions
                        :event-compitions="eventCompitions"
                    ></event-competitions>
                    <!-- <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites> -->
                </div>
            </v-list>
        </div>
        <div class="fav">
            <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites>
        </div>
    </div>
</template>

<script>
import { kebabCase, startCase } from "lodash"
import { mapState } from "vuex"
import EventCompetitions from "@/components/EventCompetitions"
import Competitions from "@/components/Competitions"
import casino from "@/assets/images/sportsbook-categories/casino.webp"
import cardicon from "@/assets/images/sportsbook-categories/cardicon.webp"
import sloticon from "@/assets/images/sportsbook-categories/sloticon.webp"
import horse from "@/assets/images/menu/horse.webp"
import greyhound from "@/assets/images/sportsbook-categories/greyhound.webp"
import Favorites from "@/components/Favorites"

export default {
    name: "SportbookCategory",
    components: { EventCompetitions, Competitions, Favorites },
    props: {
        orientation: { type: String, default: "horizontal" },
        isEmpty: { type: Boolean, default: false }
    },
    data() {
        return {
            kebabCase,
            startCase,
            domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0,
            CDN_IMG_URL: process.env.CDN_IMG_URL,
            fairplayEnv: process.env.fairplayEnvironment,
            model: null,
            scrollClass: "left-main",
            casino,
            cardicon,
            iconText: "mdi-chevron-down",
            sloticon,
            horse,
            greyhound,
            domain: process.env.DOMAIN_NAME,
            defaultLimit: this.$breakpoint.smAndDown
                ? this.$store.state.sportsbookCategory &&
                  this.$store.state.sportsbookCategory.premiumSportsbookData &&
                  this.$store.state.sportsbookCategory.premiumSportsbookData
                      .length
                : 0,
            limitBy: this.$breakpoint.smAndDown
                ? this.$store.state.sportsbookCategory &&
                  this.$store.state.sportsbookCategory.premiumSportsbookData &&
                  this.$store.state.sportsbookCategory.premiumSportsbookData
                      .length
                : 0,
            tabs: {
                settings: {
                    grow: true
                },
                mobileItems: [
                    {
                        src: "Inplay",
                        icon: "mdi-play-circle",
                        text: "Inplay",
                        status: true,
                        link: "/"
                    },
                    {
                        src: "Sportsbook",
                        icon: "iconpe-sportsbook",
                        text: "Sportsbook",
                        status: true,
                        link: "/sportsbook"
                    },
                    {
                        src: "Premium-Notebook",
                        icon: "mdi-crown",
                        text: "Premium Sportsbook",
                        status: true,
                        link: "/premium-sportsbook"
                    },
                    // {
                    //   icon: 'iconpe-live-casino',
                    //   text: 'Live Casino',
                    //   status: true,
                    //   link: '/casino'
                    // },
                    {
                        src: "Live-Card",
                        icon: "iconpe-live-cards",
                        text: "Live Card",
                        status: true,
                        link: "/live-cards"
                    }
                    // {
                    //   icon: 'iconpe-live-cards',
                    //   text: 'Live Games',
                    //   status: true,
                    //   link: '/live-games'
                    // },
                    // {
                    //   icon: 'iconpe-live-casino',
                    //   text: 'Slot Games',
                    //   status: true,
                    //   link: '/casino-slots'
                    // }
                ],
                items: [
                    {
                        src: "Inplay",
                        icon: "mdi-play-circle",
                        text: "Inplay",
                        status: true,
                        link: "/"
                    },
                    {
                        src: "cricket",
                        icon: "iconpe-cricket",
                        text: "Cricket",
                        status: true,
                        link: "/sportsbook/Cricket"
                    },
                    {
                        src: "soccer",
                        icon: "iconpe-soccer",
                        text: "Soccer",
                        status: true,
                        link: "/sportsbook/Soccer"
                    },
                    {
                        src: "tennis",
                        icon: "iconpe-tennis",
                        text: "Tennis",
                        status: true,
                        link: "/sportsbook/Tennis"
                    },
                    {
                        src: "live-cards",
                        icon: "iconpe-live-cards",
                        text: "Live Card",
                        status: true,
                        link: "/live-cards"
                    },
                    {
                        src: "slots",
                        icon: "iconpe-slots",
                        text: "Slot Games",
                        status: true,
                        link: "/casino-slots"
                    },
                    {
                        src: "horse",
                        icon: "iconpe-horse-racing",
                        text: "Horse Racing",
                        status: true,
                        link: "/sportsbook/horse-racing"
                    },
                    {
                        icon: "iconpe-live-casino",
                        text: "Finsa",
                        status: true,
                        link: "/racing"
                    }
                ]
            }
        }
    },
    computed: {
        fantasyOnOff() {
            return this.$store.state.user.fantasyConfig
        },
        version() {
            return this.$store.state.profile.appversion
        },
        filterOut() {
            return this.games
        },
        gameName() {
            return this.$route.params.category
        },
        userName() {
            return this.$store.state.auth.user
        },
        eventGameData() {
            return this.$route.params.subCategory
        },
        mobileDrawer: {
            get() {
                return this.$store.getters["mobileDrawer/value"]
            },
            set(v) {
                return this.$store.commit("mobileDrawer/toggle", v)
            }
        },
        megaMenuDrawer: {
            get() {
                return this.$store.getters["megaMenuDrawer/value"]
            },
            set(v) {
                return this.$store.commit("megaMenuDrawer/toggle", v)
            }
        },
        ...mapState({
            Auth: (state) => state.auth.user.data,
            games: (state) => state.sportsbookCategory.data,
            premiumSportsbookData: (state) =>
                state.sportsbookCategory.premiumSportsbookData,
            eventCompitions: (state) =>
                state.sportsbookCategory.eventCompetionData,
            compitions: (state) => state.sportsbookCategory.competionData,
            loading: (state) => state.sportsbookCategory.loading
        })
    },
    watch: {
        $route() {
            if (this.$breakpoint.smAndDown) {
                this.getCatergory()
                this.mobileDrawer = false
                this.megaMenuDrawer = false
            }
        }
    },
    // created() {
    //   this.activeGames()
    // },
    created() {
        this.getCatergory()
    },
    beforeDestroy() {
        this.$store.commit("sportsbookCategory/empty_data")
    },
    // async mounted() {
    //   await this.setLimit()
    // },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        getIcon(text) {
            try {
                // const imgURL = '@/assets/images/sportsbook-categories/cricket.webp'
                return require(`@/assets/images/sportsbook-categories/${text
                    .replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
                    .replace(/[\s_]+/g, "-") // replace all spaces and low1 dash
                    .toLowerCase()}.webp`)
            } catch (error) {
                return ""
            }
        },
        getIconSVG(text) {
            try {
                // return require(`@/assets/playicons/${text}`)
                return require(`@/assets/playicons/${text
                    .replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
                    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
                    .toLowerCase()}.svg`)
            } catch (error) {
                return ""
            }
        },
        getCatergory() {
            try {
                if (
                    !this.$route.params.category &&
                    !this.$route.params.subCategory
                ) {
                    this.$store.dispatch("sportsbookCategory/get")
                    this.$store.dispatch(
                        "sportsbookCategory/getPremiumSportsbook"
                    )
                    // await this.setLimit()
                    // console.log('emo1')
                    this.scrollClass = "left-main"
                } else if (
                    this.$route.params.category &&
                    !this.$route.params.subCategory
                ) {
                    // console.log('emo2')
                    this.scrollClass = "left-main-category"
                    // await this.$store.dispatch(
                    //   'sportsbookCategory/getCompetition',
                    //   this.$route.params.category
                    // )
                    this.$store.dispatch("sportsbookCategory/get")
                    this.$store.dispatch(
                        "sportsbookCategory/getPremiumSportsbook"
                    )
                } else if (
                    this.$route.params.category &&
                    this.$route.params.subCategory
                ) {
                    this.scrollClass = "left-main-subcategory"
                    this.$store.dispatch(
                        "sportsbookCategory/getEventCompetition",
                        this.$route.params.subCategory
                    )
                    this.$store.dispatch("sportsbookCategory/get")
                    this.$store.dispatch(
                        "sportsbookCategory/getPremiumSportsbook"
                    )
                } else {
                    this.$store.dispatch("sportsbookCategory/get")
                    this.$store.dispatch(
                        "sportsbookCategory/getPremiumSportsbook"
                    )
                    // await this.setLimit()
                }
            } catch (error) {}
        },
        getGameSrc(game) {
            if (game) {
                switch (game.toLowerCase()) {
                    case "horse racing":
                    case "horse-racing":
                        return this.horse
                    case "greyhound racing":
                    case "greyhound-racing":
                        return this.greyhound
                    default:
                        return this.getIcon(game)
                }
            }
        }
        // viewMore(defaultLimit, bookDataLength) {
        //   this.limitBy =
        //     this.limitBy === defaultLimit ? bookDataLength : defaultLimit
        //   this.iconText = this.limitBy === 0 ? 'mdi-chevron-down' : 'mdi-chevron-up'
        // },
        // setLimit() {
        //   if (this.$store.state.sportsbookCategory.premiumSportsbookData) {
        //     this.limitBy = this.$breakpoint.smAndDown
        //       ? this.$store.state.sportsbookCategory.premiumSportsbookData.length
        //       : 0
        //     this.defaultLimit = this.$breakpoint.smAndDown
        //       ? this.$store.state.sportsbookCategory.premiumSportsbookData.length
        //       : 0
        //   }
        // }
    }
}
</script>
<style lang="scss" scoped>
.more {
    margin: 0 !important;
    padding: 0.2rem 0;
    width: 1rem;
    height: 1.4rem;
    max-width: 100%;
    filter: brightness(0) invert(1);
}
.v-avatar {
    .v-image {
        .v-image {
            .v-image__image--cover {
                animation: float 6s ease-in-out infinite;
            }
        }
    }
}
.v-list-item--dense,
.v-list--dense .v-list-item {
    min-height: 2rem;
}
.theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item--active::before {
    opacity: 0;
}
/* height */
.height-55 {
    height: 55px;
}
/* .v-list.theme--light {
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
} */
.primary-lighten {
    background: rgba(68, 68, 68, 0.5);
}
@keyframes float {
    0% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
    50% {
        box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
        transform: translatey(-20px);
    }
    100% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
}
.horse-racing-title {
    height: 16px !important;
}
</style>
